import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  public async canActivate(): Promise<boolean> {
    const job = this.authService.isAuthenticated();
    const isAuthenticated = await job.runNoThrow();
    if (isAuthenticated) {
      this.router.navigate([`/`]);
      return false;
    }
    return true;
  }
}
